export default "__VITE_ASSET__CUdQCgGu__"